/**
 * * commonder  命令组件
 * https://github.com/tj/commander.js/blob/master/Readme_zh-CN.md
 * 
 */
const { initCommond } = require('./initCommond');
const utils = require('./utils');
let { log, commander: { Command },
    utils: { action, autoRequireFile } } = utils;

// log.mi("---------内置路径:", {
//     getMainPath: inner.getMainPath(),
//     getRootPath: inner.getRootPath(),
//     getBinPath: inner.getBinPath(),
//     getBin_appbir: inner.getBin('appbir'),
//     getBin_npm: inner.getBin('npm'),
//     getBin_node: inner.getBin('app-lib-node'),
// })

// log.mi("---------引用路径:", {
//     getMainPath: nodes.getMainPath(),
//     getRootPath: nodes.getRootPath(),
//     getBinPath: nodes.getBinPath(),
//     getBin_appbir: nodes.getBin('appbir'),
//     getBin_npm: nodes.getBin('npm'),
//     getBin_node: nodes.getBin('app-lib-node'),
// })


const program = new Command();

/**
 *  初始化日志
 */
log.auotLevel();


/**
 * 初始化命令
 */
let { registerCommond } = initCommond({ ...utils, program });

// 获取PKG.json的配置
const PKG = autoRequireFile('package.json');

// 打印显示内容
const display = async () => {
    log.mi("usage [ appbir --help ] , show support commond >")
    log.T(registerCommond);
    return 0;
}

/**
 * appbir 的总入口命令
 * 所有的debugger 命令会被外出拦截 最好不要添加其他命令
 */
program
    .version(`v${PKG.version}`, '-v,--version', 'the current version')
    .description('appbir personal cli tool for speed work, you can connection email for appbir@163.com')
    .action(action.bind(null, { start: display, commond: PKG.name }));


log.md("run.argv", JSON.stringify(process.argv.slice(2)))

/**
 * 命令解析
 */
program.parse(process.argv);
